module.exports = __webpack_public_path__ + "static/media/command_widget.a9c35cf1.jpg";